import { defineComponent, computed, toRefs, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import { capitalize } from "lodash";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "SelectMortgageType",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedMortgageType: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      selectedMortgageType,
      multiple
    } = toRefs(props);
    const select = ref();
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const mortgageTypeOptions = computed(() => [{
      id: "all",
      text: capitalize(tc("global.words.all", 1))
    }, {
      id: "first",
      text: t("application-form.first")
    }, {
      id: "second",
      text: t("application-form.second")
    }, {
      id: "third",
      text: t("application-form.third")
    }]);
    const localSelectedMortgageType = computed({
      get() {
        var _selectedMortgageType;
        return (_selectedMortgageType = selectedMortgageType.value) != null ? _selectedMortgageType : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedMortgageType", newValue);
      }
    });
    const handleChange = (selectedValue, type) => {
      var _select$value;
      if (selectedValue.id === "all") (_select$value = select.value) == null ? void 0 : _select$value.close();
      localSelectedMortgageType.value = handleSelectMultipleChange(selectedValue, type, localSelectedMortgageType.value, multiple.value);
    };
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption"),
      closeOnSelect: !multiple.value
    }));
    return {
      select,
      mortgageTypeOptions,
      localSelectedMortgageType,
      handleChange,
      options
    };
  }
});